import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { inject, observer } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import PurchaseOrderView, { PurchaseOrderSkeleton } from 'components/PurchaseOrder/PurchaseOrderView';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// A purchase order (/dashboard/purchase-orders/:id/show-purchase-order).
@inject('workReportStore', 'viewStore') @observer
class WorkReportShowPurchaseOrderPage extends Component {

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.workReportStore.loadPurchaseOrder({ uuid });
  };

  // An order that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { workReportStore: { purchaseOrderItem }, viewStore } = this.props;
    const missing = purchaseOrderItem.errorStatus === 404 || purchaseOrderItem.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to purchase orders', icon: 'arrow-left', onClick: () => viewStore.PurchaseOrder() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="shopping-cart"
            title="This purchase order isn't here"
            message="It may have been deleted, or the link may be wrong. Find it in your purchase orders instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The purchase order couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { workReportStore: { purchaseOrderItem: { isLoading, isError, object, errorStatus } } } = this.props;
    // The order's attributes are only there once it has loaded (the list's
    // search shares this slot and leaves `object` empty).
    const loaded = object && object.attributes && object.attributes.purchase_order_number !== undefined;
    let content = null;
    let title;
    if (loaded && !isLoading) {
      title = `${object.attributes.purchase_order_number} purchase order | Field Nexus`;
      content = <PurchaseOrderView key={object.id} />;
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Purchase order not found' : "Couldn't load purchase order"} | Field Nexus`;
      content = this.renderError();
    } else {
      title = 'Loading..';
      content = <PurchaseOrderSkeleton />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          {content}
        </PageWrapGray>
      </div>
    );
  }
}

export default WorkReportShowPurchaseOrderPage;
